import axios from 'axios';
import Vue from 'vue';
import router from '../router/index'

const tools = {};

axios.interceptors.response.use(function (response) {
    // 登录过期返回登陆页面
    if (response.data && (response.data.statusCode === 10201 || response.data.statusCode === 10200 || response.data.statusCode === 10002) && location.pathname !== '/login') {
        if(!router.currentRoute.fullPath.includes('/login')){
            layer.msg('登录过期，请重新登录！', function () {
                localStorage.clear()
                if(!router.currentRoute.fullPath.includes('/login')) location.href = '/login';
            })
        }
    }
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

tools.install = function(Vue, options){
    //新增的全局工具类可填写至此，例如
    Vue.prototype.getDefaultValue = function(){
        // some codes ...
        console.log(this); //这里的this将会指向调用它的Vue实例
        return 1;
    }
    //// 接口请求
    Vue.prototype.ysajax = function(url, type, data){
        // some codes ...
        var token = JSON.parse(localStorage.getItem("login")) || '';
        var _token = "";
        if(token.data && token.data.token){
            _token = token.data.token
        }
        if(type.toUpperCase() === "GET"){
            let headers = {
                "token": _token !== "" ? _token : "",
            };
            return axios.get(url, {headers,params:data});
        }else if(type.toUpperCase() === "POST"){
            let headers = {
                "token": _token !== '' ? _token : "",
            };
            return axios.post(url,data,{headers});
        }else if(type.toUpperCase() === "DELETE"){
            let headers = {
                "token": _token !== '' ? _token : "",
            };
            return axios.delete(url,{headers});
        }else if(type.toUpperCase() === "PUT"){
            let headers = {
                "token": _token !== '' ? _token : "",
            };
            return axios.put(url,data,{headers});
        }

    }

    /// 数据字典   存储
    Vue.prototype.getCommonDict = {};
    ////机构公用
    Vue.prototype.organization = {};
    Vue.prototype.orgNameList = function(name){
        let _this = this;
        _this.ysajax('/api/cry/sb/v1/dictionary/getCommonDict?code=nation_idType_staffSize_vehicleSize_workNature', "get", {}).then(function(data){
            if(data.data.statusCode === 0 ){
                Vue.prototype.getCommonDict = data.data.data
            }
        })
        _this.ysajax('/api/cry/sb/v1/organization/list', "get", {}).then(function(data){
            if(data.data.statusCode === 0 ){
                Vue.prototype.organization = data.data.data
            }
        })
    }
    Vue.prototype.orgNameList();
    // 上传图片host
    Vue.prototype.Host='http://cry-saas.oss-cn-zhangjiakou.aliyuncs.com';
    // 权限按钮
    Vue.prototype.getAuthority = function (id){
        let data={
            id:id
        }
        this.ysajax('/api/cry/sb/v1/menu/selectChildMenuListById?'+Vue.prototype.serMap(data), "get", {}).then((data)=>{
            sessionStorage.setItem('PermissionsList',JSON.stringify(data.data.data))
            Vue.prototype.PermissionsBtn=data.data.data
        })
    }

    //判断否是显示按钮
    Vue.prototype.showBtn=function(text,page,data){
        let PermissionsBtn=JSON.parse(sessionStorage.getItem('PermissionsList'));
        let roleId= JSON.parse(window.localStorage.getItem("login")).data.roleId;
        let isShow = 'none';
        if(text && PermissionsBtn){
            PermissionsBtn.forEach((item)=>{
                if(text === item.path){
                    isShow= 'inline-block';
                }
            })
        }
        return isShow;
    },
    /**
     * 将一个对象转化为‘&key1=value1&key2=value2....’格式
     * @param m{JSON} 需要转化的JSON对象,
     * @return {String}型为‘&key1=value1&key2=value2....’的字符串
     * @author daijiejian
     * @author 金颖熠——修复bug
     */
    Vue.prototype.serMap = function(m){
        // var d = "";
        // var a = 0;
        // if (m) {
        //     for (var i in m) {
        //         if (m[i] !== '' && m[i]) {
        //             a += 1
        //             if(a === 1){
        //                 d = i + "=" + encodeURIComponent(m[i])
        //             }else{
        //                 d = d + "&" + i + "=" + encodeURIComponent(m[i])
        //             }
        //         }
        //     }
        // }
        let arr = [];
        for(let key in m){
            if(m.hasOwnProperty(key)){
                if(m[key] !== '' && m[key] !== undefined){
                    arr.push(key + "=" + encodeURIComponent(m[key]));
                }
            }
        }
        return arr.join("&");
    };
    /**
     * 将日期格式化返回
     * @param date{String} 需要格式化的日期
     * @param fmt{String} 需要格式化时间的格式
     * @return fmt{String} 一个日期格式的字符串
     * @author daijiejian
     */
    Vue.prototype.format = function (date, fmt) {
        var formatDate = date == parseInt(date) ? new Date(parseInt(date)) : new Date(date);
        var fmt = fmt;
        var o = {
            "M+": formatDate.getMonth() + 1, //月份
            "d+": formatDate.getDate(), //日
            "h+": formatDate.getHours() % 12 == 0 ? 12 : formatDate.getHours() % 12,
            "H+": formatDate.getHours(), //小时
            "m+": formatDate.getMinutes(), //分
            "s+": formatDate.getSeconds(), //秒
            "q+": Math.floor((formatDate.getMonth() + 3) / 3), //季度
            "S": formatDate.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (formatDate.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    };
};

export default tools;


//添加响应拦截器

axios.interceptors.response.use(response => {
      // 登录超时跳转登录页
    //   console.log(response.status,'........')
        let token = JSON.parse(localStorage.getItem("login")) || '';
        let _token = "";
        if(token.data && token.data.token){
            _token = token.data.token
        }
      if (response.status  === 10200) {
        Vue.prototype.$Message.warning('登录超时');
        if(router.currentRoute.fullPath != '/login'){
            router.push({
                path:'/login',
                query:{url:router.currentRoute.fullPath}//回调地址
            })
        };
      } else if (response.status  === 10206){
        Vue.prototype.$Message.warning('用户已停用，请联系管理员');
        router.push({
            path:'/login',
            query:{url:router.currentRoute.fullPath}
        })
      } else if (response.status  === 10207){
        Vue.prototype.$Message.warning('用户角色已删除，请联系管理员');
        router.push({
            path:'/login',
            query:{url:router.currentRoute.fullPath}
        })
      } else if (response.status  === 10208){
        Vue.prototype.$Message.warning('用户已删除，请联系管理员');
        router.push({
            path:'/login',
            query:{url:router.currentRoute.fullPath}
        })
      } else if (response.status === 200) {
          if (router.currentRoute.fullPath.includes('/login') && _token) {
                router.push({
                    path:'/warp/companymanagement/organizationmanagement'
                })
            }
      }
      return response
    },
    error => {
        if(error.response.status == 400){
            // console.log(error,'......')
        }
      // 对响应错误做点什么
      return Promise.reject(error.response)
})

Date.prototype.formatToString = function(fmt = 'yyyy-MM-dd HH:mm:ss'){
    let o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, //小时
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    let week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
    };
    if(/(y+)/.test(fmt)){
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    if(/(E+)/.test(fmt)){
        fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[this.getDay() + ""]);
    }
    for(let k in o){
        if(new RegExp("(" + k + ")").test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
};



// WEBPACK FOOTER //
// ./src/tools/tools.js